import { render } from "./EducationalMaterials.vue?vue&type=template&id=471a0a78&lang=pug"
import script from "./EducationalMaterials.vue?vue&type=script&lang=js"
export * from "./EducationalMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__